import { render } from '@wordpress/element';

document.addEventListener('DOMContentLoaded', () => {
    console.log('view script loaded');

    // Get the map container element
    const mapContainer = document.querySelector('.fsdpe-map-wrapper');

    if (mapContainer) {
        // Initialize the map
        initMap(mapContainer);
    }
});

// Initialize the map
function initMap(mapContainer) {
    console.log('Initializing Google Map');

    const lat = parseFloat(mapContainer.getAttribute('data-latitude')) || 37.7749; // Default Latitude
    const lng = parseFloat(mapContainer.getAttribute('data-longitude')) || -122.4194; // Default Longitude

    const map = new google.maps.Map(mapContainer, {
        center: { lat, lng },
        zoom: 8,
    });

    const marker = new google.maps.Marker({
        position: { lat, lng },
        map: map,
        draggable: false,
    });
}
